import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=aec55e56&"
import script from "./Trivia.vue?vue&type=script&lang=js&"
export * from "./Trivia.vue?vue&type=script&lang=js&"
import style0 from "./Trivia.vue?vue&type=style&index=0&id=aec55e56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports